/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-23 17:39:35
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-25 10:47:46
 * @FilePath: /unifyxp-v2-store-portal/src/pages/FileDetail/Components/InstanceModal/index.tsx
 */
import React from 'react';

import { Modal } from '@/src/components/Antd';

import styles from './style.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
function InstanceModal({ visible, onCancel, instance }) {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  return (
    <Modal
      width={1080}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      title={getI18n('storeFileLibrary.detail.fileInstanceDetails')}>
      <div className={styles.container}>
        <div className={styles.left}>
          <div
            className={styles.img}
            style={{ backgroundImage: `url('${instance.url}')` }}
          />
        </div>
        <div className={styles.right}>
          <div className={styles.item}>
            <div className={styles.title}>
              {getI18n('storeFileLibrary.detail.instanceName')}
            </div>
            <div className={styles.content}>{instance.originalName}</div>
          </div>
          <div className={styles.item}>
            <div className={styles.title}>
              {getI18n('storeFileLibrary.detail.altText')}
            </div>
            <div className={styles.content}>{instance.altText}</div>
          </div>
          <div className={styles.item}>
            <div className={styles.title}>
              {getI18n('general.upload.EditModal.description')}
            </div>
            <div className={styles.content}>{instance.description}</div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default InstanceModal;
